const SimpleCell = ({ value }: { value: string | number | Date }) => (
  <div className="custom-cell-container">
    <span>{value || '--'}</span>
  </div>
);

export default SimpleCell;
